import { BaseModel } from './../classes/base-model';

export class Group extends BaseModel {
    Id?: number;
    Name?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/group.ts